<template>
    <dash
        icon="fa fa-book"
        titulo="DESPESAS"
        @click.native="$router.push({ name: 'DespesasGerais_Fornecedores_Despesas' })"
    ></dash>
</template>

<script>
import Dash from '@/shared/components/DashComponent'

export default {
    components: {
        Dash
    },

    data() {
        return {}
    }
}
</script>
